<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container v-show="showBubbleContent">
      <v-row>
        <v-col>
          <MenuListBubble :waitTime="waitTime" :errorContent="errorContent" />
        </v-col>
      </v-row>
    </v-container>

    <!-- リスト(サブグループ) -->
    <v-list expand>
      <v-list-group
        v-for="menu in menus"
        :key="menu.group.id"
        value="true"
        class="grey lighten-4"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              v-text="menu.group.name"
              class="black--text"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="child in menu.menus"
          :key="child.menuId"
          :to="{ name: 'Menu', params: { id: child.menuId } }"
          class="white"
          v-show="showMenu(child)"
        >
          <v-list-item-avatar size="80" tile>
            <ImgWrapper :src="child.t_image_url" v-if="child.t_image_url" />
            <ImgWrapper :src="noimageUrl" v-else />
          </v-list-item-avatar>
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <span>{{ child.name }}</span>
                </v-col>
              </v-row>
              <v-row justify="start" align-content="center" align="center">
                <!-- 1 -->
                <v-col cols="auto" class="pt-0 pb-0">
                  <span
                    v-if="child.stock == 0"
                    class="menu-amount text-subtitle-1"
                    >￥{{ child.amountBase }}</span
                  >
                  <span
                    v-else-if="isDiscountMenu(child)"
                    class="menu-amount text-subtitle-1 discount"
                    >￥{{ child.amountBase }}</span
                  >
                  <span v-else class="menu-amount text-subtitle-1"
                    >￥{{ child.amountBase }}</span
                  >
                </v-col>
                <!-- 2 -->
                <v-col cols="auto" class="pt-0 pb-0">
                  <!-- <v-chip
                    v-if="child.stock == 0"
                    color="red"
                    text-color="white"
                  >
                    完売
                  </v-chip> -->
                  <span v-if="child.stock == 0" class="red--text">完売</span>
                  <span v-else-if="isDiscountMenu(child)" class="red--text"
                    >￥{{ child.amountBaseEx }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { liffReady } from "../util/liff_util";
import { MSG_TYPE } from "../components/error/errorConstants";
import MenuListBubble from "./parts/MenuListBubble";
import { MSG_ORDER_NG } from "../constants/messages";
import { ORDER_ACCEPT_STATUS } from "../util/about_util";
import { PROVIDE_STATUS } from "../constants/order_constants";

const IMAGE_DEFAULT = require("@/assets/noimage.png");

export default {
  components: {
    MenuListBubble,
    ImgWrapper: () => import("./parts/ImgWrapper"),
  },
  data: () => ({
    menus: [], // 表示用
    // bubble
    showBubbleContent: false,
    waitTime: null,
    errorContent: null,
    noimageUrl: IMAGE_DEFAULT,
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "メニュー";
    this.$store.state.cart = true;
  },
  async mounted() {
    await liffReady(); // LIFF 初期化待機
    this.showProgress();

    try {
      await this.fetchData();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.push({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress", "menusViewData"]),
  },
  watch: {
    menusViewData: function () {
      if (!this.menusViewData) {
        return;
      }
      this.bindData();
    },
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchMenuListData"]),
    fetchData: async function () {
      return this.fetchMenuListData();
    },
    bindData: function () {
      this.menus = this.menusViewData.menus;
      const business = this.menusViewData.about.business;
      const orderAcceptStatus = this.menusViewData.orderAcceptStatus;
      this.createBubbleContent(business, orderAcceptStatus);
    },
    createBubbleContent: function (business, orderAcceptStatus) {
      if (orderAcceptStatus == ORDER_ACCEPT_STATUS.ACCEPTING) {
        // 注文受付中
        const waitTime = this.calcWaitTime(business);
        this.waitTime = waitTime;
      } else {
        let msg = "";
        if (orderAcceptStatus == ORDER_ACCEPT_STATUS.SUSPENDED) {
          msg = MSG_ORDER_NG.SUSPENDED; // 一時停止
        } else if (orderAcceptStatus == ORDER_ACCEPT_STATUS.NOT_ACCEPTED) {
          msg = MSG_ORDER_NG.NOT_ACCEPTED; // 受付停止
        }
        this.errorContent = msg;
      }
      this.showBubbleContent = true;
    },
    showMenu: function (menu) {
      // 「再販売未定」以外を表示
      const provideStatus = menu.provideStatus;
      return provideStatus != PROVIDE_STATUS.RESALE_UNDECIDED;
    },
    calcWaitTime: function (business) {
      let cookingMinutes = business.cookingMinutes;
      if (!Number.isInteger(cookingMinutes)) {
        cookingMinutes = 0;
      }
      let stepMinutes = business.stepMinutes;
      if (!Number.isInteger(stepMinutes)) {
        stepMinutes = 0;
      }
      return cookingMinutes + stepMinutes;
    },
    isDiscountMenu: function (menu) {
      return menu.discountStatus === 1; //TODO constants
    },
  },
};
</script>
<style>
@import "../css/common.css";
</style>